import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
  getDocById,
  updateManyByField,
} from "./firestoreHelpers";

const COLL = "alquileres_contratos";

// Cascade a renamed locador/locatario onto the denormalized name stored on each
// of its contratos. Called from updateLocador/updateLocatario so editing a ficha
// keeps every linked contrato in sync. Returns how many contratos were updated.
export const renameLocadorOnContratos = (locadorId, locadorNombre) =>
  updateManyByField(COLL, "locadorId", locadorId, { locadorNombre });

export const renameLocatarioOnContratos = (locatarioId, locatarioNombre) =>
  updateManyByField(COLL, "locatarioId", locatarioId, { locatarioNombre });

export const getContratos = async () => fetchAll(COLL);

export const getContratoById = async (id) => getDocById(COLL, id);

export const saveContrato = async (data) => createDocWithId(COLL, data);

export const updateContrato = async (id, data) => updateDocById(COLL, id, data);

export const deleteContrato = async (id) => deleteDocById(COLL, id);
